module.exports = __webpack_public_path__ + "static/media/mehndi_2.cf5d79cc.jpg";